<!--
    描述：订阅查看工具-分析tab页列表页面
    时间：2020-06-16
    Created by yefan
-->
<template>
	<div class="w-page-main analyze-page">
		<div class="w-page-header">
			<div class="w-page-header">
				<ul class="clearfix">
					<li v-for="(item,index) in itemType"
						:key="'item' + index"
						:class="{selectedColor:selectIndex === index}"
						@click="simpleClick(item,index)"><a>{{item.label}}</a></li>
				</ul>
				<div class="btnGroups ml10">
					<el-button-group>
						<el-button size="small"
								   :class="{'btnActive' : btnType == 'Information'}"
								   @click="BtnClick('Information')">信息价</el-button>
						<el-button size="small"
								   :class="{'btnActive' : btnType == 'market'}"
								   @click="BtnClick('market')">市场价</el-button>
					</el-button-group>
				</div>
			</div>
		</div>
		<div class="w-page-container">
			<div class="container-head"
				 v-show="selectIndex === 0 || selectIndex === 2">
				<el-tabs v-model="activeName"
						 type="card"
						 @tab-click="activeClick">
					<el-tab-pane v-for="(item,index) in CitysList"
								 :label="item.sname"
								 :name="item.sname"
								 :key="'item'+ index"></el-tab-pane>
				</el-tabs>
			</div>
			<div class="container-head"
				 v-show="selectIndex === 1 || selectIndex === 3">
				<el-tabs v-model="macthPrice"
						 type="card"
						 @tab-click="activeClick">
					<el-tab-pane label="价格对比"
								 name="1"></el-tab-pane>
					<el-tab-pane label="走势对比"
								 name="2"></el-tab-pane>
				</el-tabs>
			</div>
			<div class="w-table-layout w-table-page">
				<!-- 地区内分析（材料）列表 -->
				<div class="list-wrap w-table-content"
					 ref="tableContent"
					 v-if="selectIndex === 0"
					 key="listone">
					<div class="analyleft">
						<RegionalAanalysisMaterialsLeft :tabTitle="selectIndex"
														ref="RegionalAanalysisMaterialsLeft"
														@on-codes='codesChange'
						></RegionalAanalysisMaterialsLeft>
					</div>
					<div class="analyright">
						<RegionalAnalysisMaterialsRight :activeName="citysName"
														:priceType="priceType"
														:cityName='activeName'
														:codesList="codesList"
														@on-radio-change="radioChange"
														@on-second-radio="secondradioChange"
														@on-Download-pictures="DownloadPictures"
														ref="RegionalAnalysisMaterialsRight">
						</RegionalAnalysisMaterialsRight>
					</div>
				</div>
				<!-- 地区间分析（材料）列表 -->
				<div class="list-wrap w-table-content"
					 ref="tableContent"
					 v-if="selectIndex === 1  && macthPrice =='1' || selectIndex === 1  && macthPrice =='2'"
					 key="listtwo">
					<div class="analyleft">
						<InterregionalAnalysisMaterialsLeft :tabTitle="selectIndex"
															ref="InterregionalAnalysisMaterialsLeft"
															:macthPriceType="macthPrice"
															@on-codes='codesChange'
															@on-radiocodes='radioCodesChange'>
						</InterregionalAnalysisMaterialsLeft>
					</div>
					<div class="analyright">
						<InterregionalAnalysisMaterialsRight :activeName="citysName"
															 :cityName='activeName'
															 :macthPrice="macthPrice"
															 :priceType="priceType"
															 :macthCode="macthCode"
															 :CitysList="CitysList"
															 :codesList="codesList"
															 @on-radio-change="radioChange"
															 @on-Download-pictures="DownloadPictures"
															 ref="InterregionalAnalysisMaterialsRight">
						</InterregionalAnalysisMaterialsRight>
					</div>
				</div>
				<!-- 地区内分析（人工）列表 -->
				<div class="list-wrap w-table-content"
					 ref="tableContent"
					 v-if="selectIndex === 2"
					 key="listone">
					<div class="analyleft">
						<RegionalAnalysisLeft :tabTitle="selectIndex"
											  ref="RegionalAnalysisLeft"
											  @on-codes='codesChange'></RegionalAnalysisLeft>
					</div>
					<div class="analyright">
						<RegionalAnalysisRight :activeName="citysName"
											   :priceType="priceType"
											   :codesList="codesList"
											   :cityName='activeName'
											   @on-radio-change="radioChange"
											   @on-second-radio="secondradioChange"
											   @on-Download-pictures="DownloadPictures"
											   ref="RegionalAnalysisRight"></RegionalAnalysisRight>
					</div>
				</div>
				<!-- 地区间分析（人工）列表 -->
				<div class="list-wrap w-table-content"
					 ref="tableContent"
					 v-if="selectIndex === 3  && macthPrice =='1' || selectIndex === 3  && macthPrice =='2'"
					 key="listtwo">
					<div class="analyleft">
						<InterregionalAnalysisLeft :tabTitle="selectIndex"
												   ref="InterregionalAnalysisLeft"
												   :macthPriceType="macthPrice"
												   @on-codes='codesChange'
												   @on-radiocodes='radioCodesChange'></InterregionalAnalysisLeft>
					</div>
					<div class="analyright">
						<InterregionalAnalysisRight :activeName="citysName"
													:cityName='activeName'
													:macthPrice="macthPrice"
													:priceType="priceType"
													:macthCode="macthCode"
													:CitysList="CitysList"
													:codesList="codesList"
													@on-radio-change="radioChange"
													@on-Download-pictures="DownloadPictures"
													ref="InterregionalAnalysisRight"></InterregionalAnalysisRight>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

import RegionalAanalysisMaterialsLeft from './components/Regional_analysis_Materials_Left' //地区内分析左（材料）
import RegionalAnalysisMaterialsRight from './components/Regional_analysis_Materials_Right' //地区内分析右（材料）

import InterregionalAnalysisMaterialsLeft from './components/Interregional_Analysis_Materials_Left' //地区间分析左（材料）
import InterregionalAnalysisMaterialsRight from './components/Interregional_Analysis_Materials_Right' //地区间分析右（材料）

import RegionalAnalysisLeft from './components/Regional_analysis_left' //地区内分析左（人工）
import RegionalAnalysisRight from './components/Regional_analysis_right' //地区内分析右（人工）

import InterregionalAnalysisLeft from './components/Interregional_analysis_left' //地区间分析左（人工）
import InterregionalAnalysisRight from './components/Interregional_analysis_right' //地区间分析右（人工）

import { selectCitys } from '@/api/modules/analyze_tab'
export default {
	components: {
		RegionalAanalysisMaterialsLeft,
		RegionalAnalysisMaterialsRight,
		InterregionalAnalysisMaterialsLeft,
		InterregionalAnalysisMaterialsRight,
		RegionalAnalysisLeft,
		RegionalAnalysisRight,
		InterregionalAnalysisLeft,
		InterregionalAnalysisRight
	},
	data() {
		return {
			searchForm: {
				sname: ''
			},
			macthCode: {
			    type : '',
			    value : '',
			},

			//macthCode : '',
			macthPrice: '1',
			CitysList: [],
			activeName: '合肥市',
			citysName: '',
			selectIndex: 0,
			btnType: 'Information',
			priceType: 1,
			codesList: [],
			idsList: [],
			itemType: [
				{
					label: '地区内分析（材料）',
					value: '1',
					checked: false
				},
				{
					label: '地区间分析（材料）',
					value: '2',
					checked: false
				},
				{
					label: '地区内分析（人工）',
					value: '3',
					checked: false
				},
				{
					label: '地区间分析（人工）',
					value: '4',
					checked: false
				}
			],
			CitysListId: [],
			tableObj: {
				loading: false,
				tableH: 400
			},
			radioChangeType: null,
			secondradioType: null
		}
	},
	created() {},
	mounted() {
		this.$nextTick(() => {
			this.getselectCitys()
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},
	// 进入缓存页面触发
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},
	methods: {
		//价格幅度回调
		secondradioChange(val) {
			this.secondradioType = val
		},

		//环比同比价格回调
		radioChange(val) {
			this.radioChangeType = val
		},

		//获取城市
		getselectCitys() {
			selectCitys({}).then(res => {
				if (res.code === 0) {
					this.CitysList = res.data
					this.CitysListId = this.CitysList.map(v => {
						return v
					})
					this.citysName = this.CitysListId[0].id
				}
			})
		},

		//工种或材料编码点击回调
		codesChange(val) {
			let that = this
			that.codesList = val
			console.log("===============>codesList= " + JSON.stringify(that.codesList))
			switch (that.selectIndex) {
				case 0:
					if (this.radioChangeType === 3) {
						this.$refs.RegionalAnalysisMaterialsRight.clickTrend(
							this.secondradioType
						)
					} else {
						this.$refs.RegionalAnalysisMaterialsRight.clickRadio(
							this.radioChangeType
						)
					}
					break
				case 1:
					if (that.macthPrice === '1' && that.selectIndex === 1) {
						that.$refs.InterregionalAnalysisMaterialsRight.clickRadio(
							that.radioChangeType
						)
					}
					break
				case 2:
					if (that.radioChangeType === 4) {
						that.$refs.RegionalAnalysisRight.clickTrend(
							that.secondradioType
						)
					} else {
						that.$refs.RegionalAnalysisRight.clickRadio(
							that.radioChangeType
						)
					}
					break
				default:
					if (that.macthPrice === '1' && that.selectIndex === 3) {
						that.$refs.InterregionalAnalysisRight.clickRadio(
							that.radioChangeType
						)
					}
			}
		},

		//单选工种编码点击回调
		radioCodesChange(val) {
			this.macthCode = val
			console.log("======> macthCode=> " + JSON.stringify(this.macthCode))
			setTimeout(() => {
				if (this.selectIndex === 1 && this.macthPrice === '2') {
					this.$refs.InterregionalAnalysisMaterialsRight.clickMacthPrice(
						this.radioChangeType
					)
				} else if (this.selectIndex === 3 && this.macthPrice === '2') {
					this.$refs.InterregionalAnalysisRight.clickMacthPrice(
						this.radioChangeType
					)
				}
			}, 100)
		},

		//地区点击事件
		activeClick(tab, event) {
			if (this.selectIndex === 0 || this.selectIndex === 2) {
				let that = this
				let cityId = that.CitysListId.find(v => v.sname == tab.label)
				this.citysName = cityId.id

				if (this.selectIndex === 0) {
					if (this.radioChangeType === 3) {
						this.$refs.RegionalAnalysisMaterialsRight.clickTrend(
							this.secondradioType
						)
					} else {
						this.$refs.RegionalAnalysisMaterialsRight.clickRadio(
							this.radioChangeType
						)
					}
				} else if (this.selectIndex === 2) {
					if (this.radioChangeType === 4) {
						this.$refs.RegionalAnalysisRight.clickTrend(
							this.secondradioType
						)
					} else {
						this.$refs.RegionalAnalysisRight.clickRadio(
							this.radioChangeType
						)
					}
				}
			} else {
				this.macthPrice = tab.name
				if (this.selectIndex === 1) {
					if (this.macthPrice == '1') {
						this.$refs.InterregionalAnalysisMaterialsRight.clickRadio(
							this.radioChangeType
						)
					} else {
						this.$refs.InterregionalAnalysisMaterialsRight.clickMacthPrice(
							this.radioChangeType
						)
					}
				} else if (this.selectIndex === 3) {
					if (this.macthPrice == '1') {
						this.$refs.InterregionalAnalysisRight.clickRadio(
							this.radioChangeType
						)
					} else {
						this.$refs.InterregionalAnalysisRight.clickMacthPrice(
							this.radioChangeType
						)
					}
				}
			}
		},

		//btn点击事件
		BtnClick(type) {
			this.btnType = type
			this.btnType === 'Information'
				? (this.priceType = 1)
				: (this.priceType = 2)
		},

		//tab点击事件
		simpleClick(type, index) {
			this.selectIndex = index
		},

		//下载图片回调
		DownloadPictures(big, name) {
			// 获取dom
			let bigChart = big
			// 创建下载链接dom
			const link = document.createElement('a')
			link.style.display = 'none'
			link.href = bigChart.getDataURL({
				pixelRatio: 1,
				backgroundColor: '#fff'
			})
			// 文件名
			let _fileName = name
			link.download = _fileName
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		}
	},

	computed: {
		...mapState('app', { clientSize: state => state.clientSize })
	},

	watch: {
		clientSize(val) {
			this.tableObj.tableH = this.$refs.tableContent.offsetHeight
		},
		radioChangeType: {
			handler(val) {
				this.radioChangeType = val
			},
			deep: true
		}
	}
}
</script>

<style scoped lang="less">
.analyze-page {
	.btnActive {
		background: rgb(64, 158, 255);
		color: #fff;
	}
	ul {
		flex: 1;
		li {
			align-items: center;
			height: 100%;
			box-sizing: border-box;
			display: inline-block;
			list-style: none;
			font-size: 14px;
			font-weight: 500;
			color: #303133;
			cursor: pointer;
			margin-right: 10px;
			a {
				background: #f2f2f2;
				padding: 9px 15px;
			}
		}
	}
	.selectedColor {
		a {
			color: #fff;
			background: rgb(64, 158, 255);
			font-weight: 700;
		}
	}
	.container-head {
		margin-bottom: 15px;
	}
	.list-wrap {
		height: 100%;
		display: flex;
		background-color: #fff;
		.analyleft {
			width: 300px;
			height: 100%;
			padding: 0 10px 0 0;
			overflow: auto;
			border-right: 1px solid #ccc;
		}
		.analyright {
			flex: 1;
			overflow: auto;
		}
	}
}
</style>